import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Button, Grid, Popup } from 'semantic-ui-react'
import { compose } from 'recompose'

import UsersModuleHOC from './UsersModuleHOC'
import StandardError from 'Components/StandardError'
import StandardLoader from 'Components/StandardLoader'
import { withPermissions } from 'Components/Permissions'

import PageHeaderRow from 'Components/PageHeaderRow'
import Permissions from 'Components/Permissions'
import UsersTable from 'Components/UsersTable'

import * as styles from './styles'

class UsersModule extends Component {
  static propTypes = {
    setSortBy: PropTypes.func.isRequired,
    setSortOrder: PropTypes.func.isRequired,
    showCreateUserModal: PropTypes.func.isRequired,
    sortBy: PropTypes.string.isRequired,
    sortOrder: PropTypes.string.isRequired,
    users: PropTypes.array.isRequired,
  }

  handleSort = column => {
    const { setSortBy, setSortOrder, sortBy, sortOrder } = this.props

    if (sortBy === column) {
      if (sortOrder === 'ascending') {
        setSortOrder('descending')
      } else {
        setSortOrder('ascending')
      }
    } else {
      setSortBy(column)
    }
  }

  render() {
    const { showCreateUserModal, sortBy, sortOrder, users } = this.props

    return (
      <Grid>
        <PageHeaderRow title="Users" />

        <Grid.Row columns={1}>
          <Grid.Column width={16}>
            <Permissions
              permissions="users.editMode"
              render={() => (
                <div style={styles.buttonGroup}>
                  <Button.Group icon>
                    <Popup content={'Create a new User'} size="mini" trigger={<Button onClick={showCreateUserModal} icon="add" />} />
                  </Button.Group>
                </div>
              )}
            />

            <UsersTable handleSort={this.handleSort} sortBy={sortBy} sortOrder={sortOrder} users={users} />
          </Grid.Column>
        </Grid.Row>
      </Grid>
    )
  }
}

const composed = compose(
  withPermissions('modules.users'),
  UsersModuleHOC,
  StandardLoader('Calling users…'),
  StandardError,
)

export default composed(UsersModule)
